import styles from "./OrganisationProfile.module.scss";
import { useState } from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { OrganisationPersonalInfo } from "../components/OrganisationPersonalInfo/OrganisationPersonalInfo";
import { OrganisationProfileAreas } from "../components/OrganisationProfileAreas/OrganisationProfileAreas";
import { useParams } from "react-router-dom";
import { Box, Button } from "@mui/material";
import { RemoveAccountDialog } from "../components/RemoveAccountDialog/RemoveAccountDialog";
import { useTranslation } from "../i18n";

export const OrganisationProfile = () => {
  const { organisationId } = useParams<{ organisationId: string }>();
  const { t } = useTranslation();
  const [tab, setTab] = useState<number>(1);
  const [deleteAccountModal, setDeleteAccountModal] = useState<boolean>(false);

  return (
    <div className={styles.organisationProfile}>
      <TabContext value={tab.toString()}>
        <TabList
          onChange={(_e, value) => setTab(Number(value))}
          aria-label="organisation-profile-tabs"
          className={styles.tabList}
        >
          <Tab
            label={t("orgProfile.basicInfo")}
            value="1"
            className={styles.tab}
          />
        </TabList>
        <div className={styles.separator}></div>
        <TabPanel value="1" className={styles.content}>
          <OrganisationPersonalInfo />
          <OrganisationProfileAreas />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
            <Button
              variant="outlined"
              color="error"
              size="small"
              onClick={() => setDeleteAccountModal(true)}
            >
              {t("orgProfile.deleteAccount")}
            </Button>
          </Box>
        </TabPanel>
      </TabContext>
      <RemoveAccountDialog
        id={organisationId!}
        accountType="organisation"
        dialogOpen={deleteAccountModal}
        setDialogOpen={setDeleteAccountModal}
      />
    </div>
  );
};
